<script lang="ts" setup>
import DocAttributes from './DocAttributes.ce.vue';
import DocDetails from './DocDetails.ce.vue';
import DocActions from './DocActions.ce.vue';
import SaiLoader from '@/components/common/SaiLoader/index.ce.vue';
// emits
const emit = defineEmits(['handleDocAction', 'handleSelectItem', 'handleProductLinkClick']);

//props
interface Props {
  item: any,
  searchContext?: string,
  selectedItems: any[],
  activeCollectionName: string,
  docOffset: number
}
const props = withDefaults(defineProps<Props>(), {
  item: {},
  searchContext: '',
  selectedItems: () => [],
  activeCollectionName: '',
  docOffset: 0
})

</script>

<template>
    <div class="search-result-item">
      <SaiLoader v-if="item['actionProcessing']" type="threedotflash"></SaiLoader>
      <DocAttributes :item="item" @handleSelectItem="param => emit('handleSelectItem', param)" :selectedItems="selectedItems" :activeCollectionName="activeCollectionName"/>
      <DocDetails :item="item" :searchContext="searchContext" :docOffset="docOffset" :activeCollectionName="activeCollectionName" @handleProductLinkClick="emit('handleProductLinkClick')"/>
      <DocActions :item="item" @handleDocAction="param => emit('handleDocAction', param)" :activeCollectionName="activeCollectionName"/>
    </div>
</template>
<style lang="scss">
    @use './style.scss';
</style>